<div class="wrap">
  <section class="hero">
    <div class="neon">
      <h1>🧠 Operations Product Line Developer Terminal</h1>
    </div>
    <h2 class="lead">
    Welcome to the internal developer portal for operations product line. Here you'll find quick access to
    the essential tools and systems used daily by our engineering team — including CI/CD
    pipelines, code quality checks, API documentation, and monitoring dashboards. Remember
    that you need to follow the standards and always aim to perfection!
    </h2>
  </section>

  <!-- Main tool tiles -->
  <section class="deck">
    <div class="grid">
      <a *ngFor="let tool of commonTools; let first = first" 
         [class.selected]="first"
         [href]="tool.sections[0]?.links[0]?.url" 
         target="_blank" 
         rel="noopener noreferrer"
         class="tile"
         [attr.aria-label]="tool.label"
         >
        <div class="icon"><img [src]="tool.icon" alt="" /></div>
        <span class="label">{{ tool.label }}</span><br/>
        <div class="links">
              <ng-container *ngFor="let section of tool.sections">
                <a 
                  *ngFor="let link of section.links" 
                  [href]="link.url" 
                  target="_blank"
                  rel="noopener noreferrer">
                  {{ link.label }}
                </a>
              </ng-container>
            </div>
      </a>
    </div>

    <!-- Product documentation accordion - Dynamically populated -->
    <details class="subpanel" *ngIf="allProducts.length > 0" open>
      <summary><span class="chev"></span> Product Documentation Access</summary>
      <div class="subpanel-inner">
        <div class="link-grid">
          <div *ngFor="let product of allProducts" class="link-card">
            <h3 class="link-title">{{ product.emoji }} {{ product.name }}</h3>
            <div class="links">
              <ng-container *ngFor="let section of product.sections">
                <a 
                  *ngFor="let link of section.links" 
                  [href]="link.url" 
                  target="_blank"
                  rel="noopener noreferrer">
                  {{ link.label }}
                </a>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </details>
  </section>
</div>
